import { Trans } from '@lingui/react/macro';
import { Typography } from '@remarkable/ark-web';

import { Button, ErrorPage } from 'src/components';
import { URLS } from 'src/utils/urls/urls';

export const InvitationNotFound = () => {
  return (
    <ErrorPage.Container data-cy="invitation-not-found-page">
      <ErrorPage.ErrorIcon />
      <ErrorPage.Heading>
        <Trans>Invitation not found</Trans>
      </ErrorPage.Heading>

      <ErrorPage.Content>
        <div className="mx-auto flex h-full max-w-lm flex-col items-center justify-center gap-32">
          <Typography variant="body-md">
            <Trans>
              Your invitation to this subscription couldn&apos;t be found. It
              may already have been accepted. To join, please contact the person
              who invited you.
            </Trans>
          </Typography>

          <Button as="a" to={URLS.HOME} variant="secondary">
            <span>
              <Trans>Back to home</Trans>
            </span>
          </Button>
        </div>
      </ErrorPage.Content>
    </ErrorPage.Container>
  );
};
